export type Locale = 'en-US' | 'fr-CA';

export type Namespace =
  | 'common'
  | 'auth'
  | 'timeline'
  | 'settings'
  | 'onboarding'
  | 'upload'
  | 'photo'
  | 'invite'
  | 'profile'
  | 'errors'
  | 'marketing'
  | 'activity';

export const SUPPORTED_LOCALES: Locale[] = ['en-US', 'fr-CA'];
export const DEFAULT_LOCALE: Locale = 'en-US';
export const LOCALE_LABELS: Record<Locale, string> = {
  'en-US': 'English (US)',
  'fr-CA': 'Fran\u00e7ais (Canada)',
};
export const NAMESPACES: Namespace[] = [
  'common',
  'auth',
  'timeline',
  'settings',
  'onboarding',
  'upload',
  'photo',
  'invite',
  'profile',
  'errors',
  'marketing',
  'activity',
];
export const DEFAULT_NAMESPACE: Namespace = 'common';
